// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2H20V16H5.82046L1 19.4432V2ZM23.5 4.5V22.9432L18.6795 19.5H7.5V17.5H19.3205L21.5 19.0568V4.5H23.5Z"}}]};

const ChatDoubleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-double-filled',
    ref,
    icon: element,
  },
));

ChatDoubleFilledIcon.displayName = 'ChatDoubleFilledIcon';

export default ChatDoubleFilledIcon;
